/* eslint-disable prettier/prettier */
import { Route, Switch } from 'react-router-dom';

import authenticateVendor from '~/components/common/auth/AuthenticateVendor';
import { loadable } from '~/util/routeUtils';

import ClientRouter from '../ClientRouter';

const StorefrontPreview = loadable(() => import('~/pages/couples/storefronts/StorefrontPreview'));

const VendorsPreviewRoutes = () => (
  <ClientRouter>
    <Switch>
      <Route
        exact
        path="/wedding-vendors/split-view/:slug/preview"
        component={StorefrontPreview}
      />
      <Route
        exact
        path="/wedding-vendors/:vendorType(wedding-[A-Za-z-]+)/:slug/preview"
        component={authenticateVendor(StorefrontPreview)}
      />
    </Switch>
  </ClientRouter>
);

export default VendorsPreviewRoutes;
